import * as angular from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../service-areas/angular/types/service-areas-service.type";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {ResourcesService} from "./services/resources-service.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {GroupModel} from "../groups/models/group.model";
import {ServiceAreasService} from "../service-areas/services/service-areas-service.service";

angular
  .module('bringoz.admin.resources')
  .config(planningConfig);

/* @ngInject */
function planningConfig($stateProvider, moment) {

  $stateProvider

    .state('resources', {
      parent: 'bringoz.site',
      abstract: true,
      url: '/resources',
      template: '<ui-view></ui-view>',
      controller: function (site) {
      }
    })

    // Allocations View
    .state('resources.allocations', {
      url: '/allocations?:from&:to&:serviceAreaIds&:agentType&:isActive&:agentSkills&:branchIds&:depotIds&:customerIds&:accountIds&:queryString&:groupIds',
      controllerAs: 'vm',
      template: '<resources-allocations-view from="vm.from" to="vm.to" '
        + 'view-type="vm.viewType" branch-ids="vm.branchIds" '
        + 'service-area-ids="vm.serviceAreaIds" service-areas="vm.serviceAreas" agent-type="vm.agentType" query-string="vm.queryString" agent-skills="vm.agentSkills"' +
        ' is-active="vm.isActive" selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType" allow-branch-select="true"' +
        'group-ids="vm.groupIds" groups-branch-ids="vm.groupsBranchIds" account-ids="vm.accountIds" depot-ids="vm.depotIds" customer-ids="vm.customerIds"></resources-allocations-view>',
      controller: function (serviceAreas, triBreadcrumbsService, commonsService: CommonsService,
                            viewFilterSettingsService: ViewFilterSettingsService, $state, $stateParams, dateRangeTimeFiltersService: DateRangeTimeFiltersService, groups, site) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.from = moment().startOf('week').valueOf();
        this.to = moment().endOf('week').valueOf();

        this.viewType = 'week';
        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || quickActiveFilter?.settings.groupIds || [];
        this.groupsBranchIds = [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.groupsBranchIds = this.groupsBranchIds.concat(g.branchIds);
            }
          });
        }

        this.branchIds = _.uniq(this.groupsBranchIds.concat(commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || []));
        this.serviceAreas = serviceAreas || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;
        this.isActive = !_.isUndefined($stateParams.isActive) ? JSON.parse($stateParams.isActive) : (!_.isUndefined(quickActiveFilter?.settings?.isActive) ? quickActiveFilter?.settings.isActive : true);
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills;
        this.depotIds = commonsService.parseArrayStateParam($stateParams.depotIds) || quickActiveFilter?.settings.depotIds;
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || quickActiveFilter?.settings.accountIds;
        this.customerIds = commonsService.parseArrayStateParam($stateParams.customerIds) || quickActiveFilter?.settings.customerIds;
        this.queryString = $stateParams.queryString;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Allocations"});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      },
      resolve: {
        serviceAreas: function (serviceAreasService: ServiceAreasService, site) {
          const serviceAreasServiceTypes = [ServiceAreasServiceType.Planning];
          return serviceAreasService.getAll({serviceTypes: serviceAreasServiceTypes});
        },
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        }
      }
    })

    // Allocations View>
    .state('resources.gantt', {
      url: '/gantt?:from&:to&:branchIds&:areaIds&:isActive&:agentSkills&:dateRangeTemplateType',
      params: {
        overrideActive: null,
      },
      controllerAs: 'vm',
      template: '<resources-gantt-view from="vm.from" to="vm.to" '
        + 'resources="vm.resources" view-type="vm.viewType" branch-ids="vm.branchIds" is-active="vm.isActive" '
        + 'service-area-ids="vm.serviceAreaIds" agent-skills="vm.agentSkills" allow-branch-select="true" ' +
        'selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType"></resources-gantt-view>',
      controller: function ($stateParams, $state, commonsService: CommonsService, dateRangeTimeFiltersService: DateRangeTimeFiltersService, resources, serviceAreas,
                            triBreadcrumbsService, quickFilterContextService: QuickFilterContextService, viewFilterSettingsService: ViewFilterSettingsService, site) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.from;
        this.to;

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        }

        this.viewType = 'week';

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.resources = _.sortBy(resources || [], ['name']);

        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings?.branchIds || viewFilterSettingsService.getBranchIds() || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings?.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings?.agentSkills;
        this.isActive = !!$stateParams.overrideActive || (!!$stateParams.isActive ? JSON.parse($stateParams.isActive) : quickActiveFilter?.settings?.isActive);

        if ($stateParams.overrideActive) {
          $state.go('.', {isActive: true}, {notify: false, reload: false});
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Gantt"});
        triBreadcrumbsService.addCrumb({name: 'Planning'});
      },
      resolve: {
        resources: function (commonsService: CommonsService, resourcesService: ResourcesService, $stateParams, site) {
          const branchIds = $stateParams.branchIds ? commonsService.parseArrayStateParam($stateParams.branchIds) : [];
          const agentSkills = $stateParams.agentSkills;
          const serviceAreaIds = $stateParams.areaIds ? commonsService.parseArrayStateParam($stateParams.areaIds) : [];
          return resourcesService.getResources(branchIds, undefined, serviceAreaIds, undefined, agentSkills);
        },
        // allocations: function(resourcesService, resources, $q, site) {
        //    var from = moment().startOf('week').valueOf(),
        //        to = moment().endOf('week').valueOf();
        //
        //    return resources && resources.length ? ResourcesService.getTimelineAllocations(from, to) : $q.when([]);
        // },
        serviceAreas: function (serviceAreasService: ServiceAreasService, site) {
          const serviceAreasServiceTypes = [ServiceAreasServiceType.Planning];
          return serviceAreasService.getAll({serviceTypes: serviceAreasServiceTypes});
        }
      }
    })

}
